import {FETCH_RESULT, LIST_RESULT, DRAW_RESULT} from "../reducers/result/types";
import axios from "axios";
import {Env} from "../../config";

// Add a request interceptor
axios.interceptors.request.use(function (config) {

    config.baseURL = Env.REACT_APP_API_BASE_URL;
    config.headers["platform-type"] = "THINHNAM";
    config.headers["Content-Type"] = "application/json";
    config.headers["Accept"] = "application/json";

    return config;

});

axios.interceptors.response.use((response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, (error) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    try {
        const status = error?.response?.status;
        console.log(status)
    } catch (e) {
    }

    return Promise.reject(error);
});


export const fetchResults = (params = {}) => dispatch => {
    dispatch({type: FETCH_RESULT});
    return axios.get("api/v1.0.0/tns/result", {params: params}).then(response => {
        dispatch({
            type: LIST_RESULT,
            payload: response.data
        });
        return response;
    });
};

export const setDrawingResult = (data) => dispatch => dispatch({
    type: DRAW_RESULT,
    payload: data
})
